import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '@/lib/utils';
const cardVariants = cva('rounded-3xl border bg-ink-900/60 backdrop-blur-sm transition-shadow duration-200', {
    variants: {
        variant: {
            default: 'border-ink-700/60 shadow-card hover:shadow-card-hover',
            elevated: 'border-ink-700/60 shadow-card-hover',
            glow: 'border-electric-500/40 shadow-glow-electric',
            flame: 'border-flame-500/40 shadow-glow-flame',
            royal: 'border-royal-500/40 shadow-glow-royal',
            gold: 'border-gold/40 shadow-glow-gold',
            ghost: 'border-transparent bg-transparent backdrop-blur-0 shadow-none',
        },
        interactive: {
            true: 'cursor-pointer hover:-translate-y-0.5 active:translate-y-0',
            false: '',
        },
        padding: {
            none: 'p-0',
            sm: 'p-3',
            md: 'p-5',
            lg: 'p-7',
        },
    },
    defaultVariants: {
        variant: 'default',
        interactive: false,
        padding: 'md',
    },
});
export const Card = forwardRef(function Card({ className, variant, interactive, padding, ...props }, ref) {
    return (_jsx("div", { ref: ref, className: cn(cardVariants({ variant, interactive, padding }), className), ...props }));
});
export function CardHeader({ className, ...props }) {
    return _jsx("div", { className: cn('mb-3 flex items-center justify-between gap-3', className), ...props });
}
export function CardTitle({ className, ...props }) {
    return (_jsx("h3", { className: cn('font-display text-lg font-semibold uppercase tracking-wide text-ink-50', className), ...props }));
}
export function CardDescription({ className, ...props }) {
    return _jsx("p", { className: cn('text-sm text-ink-300', className), ...props });
}
export function CardContent({ className, ...props }) {
    return _jsx("div", { className: cn('text-ink-100', className), ...props });
}
export function CardFooter({ className, ...props }) {
    return _jsx("div", { className: cn('mt-4 flex items-center gap-3', className), ...props });
}
